import { Dispatch, SetStateAction } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "../../../components/ui/dialog";
import { Button } from "../../../components/ui/button";
import { Label } from "../../../components/ui/label";
import { Input } from "../../../components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../../components/ui/select";

interface ChartsOfAccountModalPropType {
  open: boolean;
  setIsModalOpen: Dispatch<SetStateAction<boolean>>;
  accountData?: any;
  onSave?: (data: any) => void;
}

const ChartsOfAccountListEditModal = ({
  open,
  setIsModalOpen,
  accountData,
  onSave,
}: ChartsOfAccountModalPropType) => {
  return (
    <Dialog open={open} onOpenChange={setIsModalOpen}>
      <DialogContent className="sm:max-w-[425px] p-0">
        <DialogHeader className="p-4 border-b BookEZ_card_border_color">
          <DialogTitle className="!text-xl">Account Details</DialogTitle>
        </DialogHeader>
        <div className="px-4 pb-4">
          {/* Edit Form */}
          <div className="grid gap-4 mt-5">
            <div className="grid gap-2">
              <Label htmlFor="name">Name</Label>
              <Input
                id="name"
                defaultValue={accountData?.name || ""}
                placeholder="Enter account name"
              />
            </div>
            <div className="grid gap-2">
              <Label htmlFor="type">Type</Label>
              <Select defaultValue={accountData?.type || "ASSET"}>
                <SelectTrigger>
                  <SelectValue placeholder="Select type" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="EXPENSE">Expenses</SelectItem>
                  <SelectItem value="REVENUE">Revenue</SelectItem>
                  <SelectItem value="ASSET">Assets</SelectItem>
                  <SelectItem value="LIABILITY">Liabilities</SelectItem>
                </SelectContent>
              </Select>
            </div>
            <div className="grid gap-2">
              <Label htmlFor="subType">Sub Type</Label>
              <Input
                id="subType"
                defaultValue={accountData?.sub_type || ""}
                placeholder="Enter sub type"
              />
            </div>
            <div className="grid gap-2">
              <Label htmlFor="balance">Balance</Label>
              <Input
                id="balance"
                defaultValue={accountData?.balance || ""}
                placeholder="0.00"
              />
            </div>
          </div>

          {/* Action Buttons */}
          <div className="flex justify-end gap-3 border-t BookEZ_card_border_color mt-6 pt-4">
            <Button variant="outline" onClick={() => setIsModalOpen(false)}>
              Cancel
            </Button>
            <Button
              variant="outlineBlack"
              onClick={() => {
                onSave && onSave({});
                setIsModalOpen(false);
              }}
              className="flex gap-2 transition-all duration-200"
            >
              Save Changes
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ChartsOfAccountListEditModal;
